module.exports = __webpack_public_path__ + "img/curriculum--vitae.2b4dfe09.svg";